<template>
   <div id="flight-informations-wrapper" class="gts-box with-border">
      <span class="section-title">{{ $t("flightInformationsComponent_flightInformation") }}</span>

      <!-- loop for legs -->
      <div class="leg-container" v-for="(leg, index) in data" :key="index">
         <!-- loop for segments -->

         <FlightLeg :leg="leg" />

         <div class="flight-brands-pointer-wrapper" :class="IsPriceDifference ? '' : 'has-price-difference'">
            <template v-if="PricePerLeg">
               <FlightBrands
                  :brands="leg.brands"
                  :ssrs="leg.extraSsrs"
                  :leg-index="index"
                  :flight-identifier="leg.flightIdentifier"
                  :price-per-leg="PricePerLeg"
                  :data="data"
                  :identifier-list="flightIdentifiers" />
            </template>
            <template v-else-if="!PricePerLeg && Object.keys(data).length == Number(index)">
               <FlightBrands
                  :brands="leg.brands"
                  :ssrs="leg.extraSsrs"
                  :leg-index="index"
                  :flight-identifier="leg.flightIdentifier"
                  :price-per-leg="PricePerLeg"
                  :data="data"
                  :identifier-list="flightIdentifiers" />
            </template>
         </div>

         <template v-if="checkoutSSRS[leg.index] && checkoutSSRS[leg.index].columns && checkoutSSRS[leg.index].columns.length > 0">
            <template v-if="IsMobile">
               <div class="ssr-mobile-only">
                  <CheckoutSSRsV2 :data="checkoutSSRS[leg.index]" :flight-identifier="leg.flightIdentifier" />
               </div>
            </template>
            <template v-else>
               <div class="ssr-desktop-only">
                  <CheckoutSSRs :data="checkoutSSRS[leg.index]" :flight-identifier="leg.flightIdentifier" />
               </div>
            </template>
         </template>
      </div>
   </div>
</template>

<script>
import { formatCheckoutSsrs } from "@/helper/checkoutSsrs";
import FlightLeg from "@/components/structural/flight/common/FlightLeg.vue";
import FlightBrands from "./brands/FlightBrands.vue";

import CheckoutSSRs from "./CheckoutSSRs.vue";
import CheckoutSSRsV2 from "@/components/structural/flight/checkout/CheckoutSSRsV2.vue";
export default {
   name: "FlightInformations",
   components: {
      FlightLeg,
      FlightBrands,
      CheckoutSSRs,
      CheckoutSSRsV2,
   },
   data() {
      return {
         legColor: {},
         legColorActive: false,
         data: {},
         flightIdentifiers: [],
         checkoutSSRS: {},
      };
   },

   computed: {
      IsMobile() {
         return this.$store.state.app.clientInformations.isMobile;
      },
      PricePerLeg() {
         return this.$store.state.flight.checkout.response.pricePerLeg;
      },
      IsPriceDifference() {
         return !this.$store.state.flight.checkout.isPriceDifference;
      },
   },
   methods: {
      handleAirlineColor(value) {
         const self = this;
         this.$set(self.legColor, value.legIndex, value);
         self.legColorActive = true;
      },
   },
   watch: {
      "$store.state.flight.checkout.response.legs": {
         handler: function () {
            const self = this;
            self.data = self.$store.state.flight.checkout.response.legs;

            const legs = self.$store.state.flight.checkout.response.legs;
            const paxes = self.$store.state.flight.checkout.response.paxes;

            if (!legs || !paxes) return;

            this.checkoutSSRS = formatCheckoutSsrs(legs, paxes);
         },
         immediate: true,
      },
   },
};
</script>

<style lang="scss" scoped>
#flight-informations-wrapper {
   margin-top: 1rem !important;
   .leg-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0;
      background-image: linear-gradient(to right, var(--gray-300) 33%, var(--gray-0-alpha-90) 0%);
      background-position: bottom;
      background-size: 17px 2px;
      background-repeat: repeat-x;
      background-position: bottom;
      margin-bottom: 2rem;
      padding-bottom: 2rem;

      &:last-child {
         background-image: none !important;
      }

      .has-price-difference {
         pointer-events: none;
      }

      .flight-brands-pointer-wrapper {
         display: flex;
         width: 100%;
      }
   }
}

.ssr-mobile-only {
   display: none;
   width: 100%;
}

@media (max-width: 1200px) {
   .ssr-desktop-only {
      display: none;
   }

   .ssr-mobile-only {
      display: block;
   }
}
</style>
